// @flow

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Link from 'app/common/components/Link';
import { addTruthyParamsToUrl } from 'app/common/utils/UrlUtils';
import { getQueryParams } from 'app/common/utils/RouterSelectors';

type HrefParams = { href: string };

const mapStateToProps = (state: Object, { href }: HrefParams): HrefParams => ({
  href: addTruthyParamsToUrl(href, getQueryParams(state)),
});

const LinkPreserveParamsContainer = connect(mapStateToProps)(Link);

LinkPreserveParamsContainer.propTypes = {
  href: PropTypes.string,
};

export default LinkPreserveParamsContainer;
